import React from 'react';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';

/**
 * DownloadButton — window.location.href download.
 * Server responds with Content-Disposition: attachment → browser downloads.
 */
export function DownloadButton({ url, children, filename, variant = "outline", size = "sm", className = "", ...props }) {
  const token = localStorage.getItem('punchtm-token');
  const sep = (url && url.includes('?')) ? '&' : '?';
  const href = (url && url !== '#' && token) ? `${url}${sep}token=${token}` : null;

  const handleClick = () => {
    if (!href) return;
    toast.info('Téléchargement en cours...');
    window.location.href = href;
  };

  return (
    <Button
      variant={variant}
      size={size}
      className={className}
      onClick={handleClick}
      disabled={!href}
      data-testid={props['data-testid']}
    >
      {children}
    </Button>
  );
}
